import {
  assetHierarchyFilters
  // userGroupsFilter,
  // userGroupsPager,
  // applicationsPager,
  // applicationsFilter,
  // assetHierarchyImport,
} from './cacheKeyFunctions';

// Here you define the default values for local apollo state (@client only values)
// https://www.apollographql.com/docs/react/local-state/local-state-management/

// const assetHierarchyDefaultFilters = {
//   fullTextFilter: { value: null, label: "General.Search" },
//   hierarchyProvider: { value: null, label: "AssetHierarchy.List.Filter.HierarchyProvider" },
//   assetType: { value: null, label: "AssetHierarchy.List.Filter.AssetType" },
//   hierarchy: { value: [], label: null }
// };

// const defaultUserGroupsPager = {
//   afterId: 1,
//   totalCount: 0,
//   pageSize: 10,
//   direction: 1,
//   page: 0,
//   sortBy: "UserGroupId"
// };

// const defaultUserGroupsFilter = {
//   userGroupName: { value: null }
// };

// const defaultApplicationsFilters = {
//   appName: { value: null, label: "AppName", type: filterType.string }
// };

// const defaultApplicationsPager = {
//   afterId: 0,
//   totalCount: 0,
//   pageSize: 10,
//   direction: 1,
//   page: 0,
//   sortBy: "AppName"
// };

// const defaultAssetHierarchyImport = {
//   status: [],
//   importRunning: false,
//   selectedProviders: {
//     EUROTAX: false,
//     GTMOTIVE: false,
//     CHARISMA: false
//   },
//   enabledProviders: {
//     EUROTAX: false,
//     GTMOTIVE: false,
//     CHARISMA: false
//   }
// };

// export const defaults = {
//   [assetHierarchyFilters.main]: assetHierarchyDefaultFilters,
//   [assetHierarchyFilters.minor]: assetHierarchyDefaultFilters,
//   [userGroupsPager]: defaultUserGroupsPager,
//   [userGroupsFilter]: defaultUserGroupsFilter,
//   [applicationsFilter]: defaultApplicationsFilters,
//   [applicationsPager]: defaultApplicationsPager,
//   [assetHierarchyImport]: defaultAssetHierarchyImport,
// };

export const defaultApolloCache = {
  ROOT_QUERY: {
    initializationParametersFilters: {
      __typename: 'initializationParametersFilters'
      //...defaultInitializationParametersFilters
    },
    dictionaryFilters: {
      __typename: 'dictionaryFilters'
      //...defaultDictionaryFilters
    },
    requiredDocumentsFilters: {
      __typename: 'requiredDocumentsFilters'
      //...defaultRequiredDocumentsFilters
    },
    checklistFilters: {
      __typename: 'checklistFilters'
      //...defaultChecklistFilters
    },
    commissionCalculationMethodsListFilters: {
      __typename: 'commissionCalculationMethodsListFilters'
      //...defaultCommissionCalculationMethodListFilters
    },
    templatesListFilter: {
      __typename: 'templatesListFilter'
      //...defaultTemplatesListFilter
    },
    genericEntityFlowFilters: {
      __typename: 'genericEntityFlowFilters'
      //...defaultGenericEntityFlowFilters
    },
    [assetHierarchyFilters.main]: {
      __typename: 'AssetHierarchyFilters'
      //...assetHierarchyDefaultFilters
    },
    [assetHierarchyFilters.minor]: {
      __typename: 'AssetHierarchyFilters'
      //...assetHierarchyDefaultFilters
    },
    userGroupsFilter: {
      __typename: 'userGroupsFilter'
      //...defaultUserGroupsFilter
    },
    authorizationsFilter: {
      __typename: 'authorizationsFilter'
      //...defaultAuthorizationsFilter
    },
    partnerTypeListFilter: {
      __typename: 'partnerTypeListFilter'
      //...defaultPartnerTypeListFilter
    },
    refinedAuthorizationsFilter: {
      __typename: 'refinedAuthorizationsFilter'
      //...defaultRefinedAuthorizationsFilter
    },
    documentTypesListFilters: {
      __typename: 'documentTypesListFilters'
      //...defaultDocumentTypesListFilters
    },
    verificationTypesFilters: {
      __typename: 'verificationTypesFilters'
      //...defaultVerificationTypesFilters
    },
    reportsFilters: {
      __typename: 'reportsFilters'
      //.//..defaultReportsFilters
    },
    reportsVerificationFilters: {
      __typename: 'reportsVerificationFilters'
      //...defaultReportsVerificationFilters
    },
    propertyListFilter: {
      __typename: 'propertyListFilter'
      //...defaultPropertyListFilters
    },
    assetHierarchyImport: {
      __typename: 'assetHierarchyImport'
      //...defaultAssetHierarchyImport
    },
    approvalTypeListFilters: {
      __typename: 'approvalTypeListFilters'
      //...defaultApprovalTypeListFilters
    },
    documentClauseListFilters: {
      __typename: 'documentClauseListFilters'
      //...defaultDocumentClauseListFilters
    },
    incomeSourceFilters: {
      __typename: 'incomeSourceFilters'
      //...defaultIncomeSourceFilters
    },
    financialIndicatorsFilters: {
      __typename: 'financialIndicatorsFilters'
      //...defaultFinancialIndicatorsFilters
    },
    scoringCategoryFilters: {
      __typename: 'scoringCategoryFilters'
      //...defaultScoringCategoryFilters
    },
    automaticStateTransitionListFilters: {
      __typename: 'automaticStateTransitionListFilters'
      //...defaultAutomaticStateTransitionListFilters
    },
    competenceOrderListFilters: {
      __typename: 'competenceOrderListFilters'
      //...defaultCompetenceOrderListFilters
    },
    engineAttributeListFilters: {
      __typename: 'engineAttributeListFilters'
      //...defaultEngineAttributeListFilters
    },
    engineScoringFilters: {
      __typename: 'engineScoringFilters'
      //...defaultEngineScoringFilters
    },
    questionnairesFilters: {
      __typename: 'questionnairesFilters'
      //...defaultQuestionnairesFilters
    },
    insuranceConventionsListFilter: {
      __typename: 'insuranceConventionsListFilter'
      //...defaultInsuranceConventionsListFilter
    },
    itemsListFilter: {
      __typename: 'itemsListFilter'
      //...defaultItemsListFilters
    },
    genericFilterParamsFilters: {
      __typename: 'genericFilterParamsFilters'
      //...defaultGenericFilterParamListFilters
    },
    genericFilterTemplatesListFilters: {
      __typename: 'genericFilterTemplatesListFilters'
      //...defaultGenericFilterTemplateListFilters
    },
    exchangeRatesFilters: {
      __typename: 'exchangeRatesFilters'
      //...defaultExchangeRatesFilters
    },
    TaxRateListFilters: {
      __typename: 'TaxRateListFilters'
      //...defaultTaxRateListFilters
    },
    financialProductsFilters: {
      __typename: 'financialProductsFilters'
      //...defaultFinancialProductsFilters
    },
    leasingInterestsListFilter: {
      __typename: 'leasingInterestsListFilter'
      //...defaultLeasingInterestsFilters
    },
    leasingCommissionsListFilters: {
      __typename: 'leasingCommissionsListFilters'
      //...defaultLeasingCommissionsListFilters
    },
    documentTypePropertiesListFilters: {
      __typename: 'documentTypePropertiesListFilters'
      //...defaultDocumentTypePropertiesListFilters
    },
    leasingInterestTypeDetailsFilters: {
      __typename: 'leasingInterestTypeDetailsFilters'
      //...defaultLeasingInterestTypeDetailsFilters
    },
    serverErrorHandlingEventKeys: {
      __typename: 'serverErrorHandlingEventKeys',
      keys: []
    },
    __typename: 'Query'
  }
};
